export const selectRoles = (state) => state.companyRoles?.roles || [];
export const selectRoleLoading = (state) => state.companyRoles?.loading || false;
export const selectRoleError = (state) => state.companyRoles?.error || null;
export const selectSelectedRole = (state) => state.companyRoles?.selectedRole || null;

// Additional useful selectors
export const selectActiveRoles = (state) =>
  state.companyRoles?.roles?.filter((role) => role.status === "active") || [];
export const selectSystemRoles = (state) =>
  state.companyRoles?.roles?.filter((role) => role.is_system === 1) || [];
export const selectTenantRoles = (state, tenantId) =>
  state.companyRoles?.roles?.filter((role) => role.tenant_id === tenantId) || [];
export const selectRoleById = (state, roleId) =>
  state.companyRoles?.roles?.find((role) => role.id === roleId) || null;
